import React from 'react';
import { Typography, Card } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph, Text } = Typography;

const PrivacyPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div style={{ padding: 24, maxWidth: 900, margin: '0 auto' }}>
      <Title level={1}>{t('legal.privacy_title')}</Title>
      <Card style={{ marginTop: 16 }}>
        <Paragraph>{t('legal.privacy_intro')}</Paragraph>
        <Paragraph>
          <Text strong>1. Cookies / 本地存储</Text>
        </Paragraph>
        <Paragraph type="secondary">
          {t('common.not_found', {
            defaultValue:
              'We only store minimal preferences such as language. No tracking cookies.',
          })}
        </Paragraph>
        <Paragraph>
          <Text strong>2. 数据收集</Text>
        </Paragraph>
        <Paragraph type="secondary">
          {t('common.not_found', {
            defaultValue:
              'We collect minimal data required to operate features. No selling of data.',
          })}
        </Paragraph>
      </Card>
    </div>
  );
};

export default PrivacyPage;
